module.exports = __webpack_public_path__ + "img/2.01ef7394.jpg";